module.exports = __webpack_public_path__ + "VIPH4.png?5fde0d67b534aa27d45c9c8a5a480e58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH4.png
// module id = 97
// module chunks = 0